import { Scene } from "phaser";

export default class Pause extends Scene {

    constructor() {
        super({ key: "Pause" });
    }

    init(data) {
        // this.fullPreviousScene = data.scene;
        this.previousScene = data.scene;
    }

    preload() {
    
        if (this.sys.game.device.os.desktop) {
            this.isMobile = false;
        }
        else {
            this.isMobile = true;
        }


    }
    create() {

        const screenCenterX = this.cameras.main.worldView.x + this.cameras.main.width / 2;
        const screenCenterY = this.cameras.main.worldView.y + this.cameras.main.height / 2;

        this.cameras.main.setBackgroundColor('#333333');

        const w = this.textures.get('backgroundSettings').getSourceImage().width;
        const h = this.textures.get('backgroundSettings').getSourceImage().height;

        let scaleX = this.cameras.main.width / w;
        let scaleY = this.cameras.main.height / h;
        let scale1 = Math.max(scaleX, scaleY)
        this.imageBackground = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, `backgroundSettings`).setScale(scale1).setScrollFactor(0);

        this.imagePause = this.add.image((screenCenterX /2 + 15), (screenCenterY/ 2) - 40, `menu-pause`).setScale(2.5).setOrigin(0, 0).setScrollFactor(0);


        //  32px radius on the corners
        // this.graphics.fillRoundedRect(screenCenterX /2, screenCenterY/ 2, screenCenterX, screenCenterY - 50, 10);
        // this.graphics.strokeRoundedRect(screenCenterX / 2 , screenCenterY /2 , screenCenterX, screenCenterY - 50, 10);

        this.textPausa = this.add.bitmapText(405, 210, 
            'pixelfont', "Pause".toUpperCase(), 30).setTint(0xffffff).setDepth(1).setScrollFactor(0).setOrigin(0.5);
        this.textHome = this.add.bitmapText(400, 210, 
            'pixelfont', "Do you want to continue? \n\nyou will return to the hotel\n hallway (level selector).".toUpperCase(), 10, 1).setTint(0xffffff).setDepth(1).setScrollFactor(0).setOrigin(0.5).setVisible(false)
        this.textRestart= this.add.bitmapText(400, 195, 
            'pixelfont', "Select the option you want to restore".toUpperCase(), 10).setTint(0xffffff).setDepth(1).setScrollFactor(0).setOrigin(0.5).setVisible(false)
        this.textRestartCharacter= this.add.bitmapText(400, 225, 
            'pixelfont', "Restart character".toUpperCase(), 10).setTint(0xf2c763).setDepth(1).setScrollFactor(0).setOrigin(0.5).setVisible(false).setInteractive({ useHandCursor: true })
        this.textRestartCharacter2= this.add.bitmapText(400, 250, 
            'pixelfont', "Restart all proccess".toUpperCase(), 10).setTint(0xf2c763).setDepth(1).setScrollFactor(0).setOrigin(0.5).setVisible(false).setInteractive({ useHandCursor: true })
        this.textCharacter= this.add.bitmapText(405, 210, 
            'pixelfont', "Do you want to continue? \n\nThe only effect will be the character change \n\nall your progress remains the same."
            .toUpperCase(), 10, 1).setTint(0xffffff).setDepth(1).setScrollFactor(0).setOrigin(0.5).setVisible(false)
        
        this.textRestartAll= this.add.bitmapText(405, 210, 
            'pixelfont', "Do you want to continue? \nyou will lose all your progress and return \nto the character selection screen. \n\nthis restart everything"
            .toUpperCase(), 10, 1).setTint(0xffffff).setDepth(1).setScrollFactor(0).setOrigin(0.5).setVisible(false)


        this.play = this.add.image(screenCenterX - 100, screenCenterY + 20,'play').setScale(1.5).setInteractive({ useHandCursor: true }).setDepth(1);
        this.soundOn = this.add.image(screenCenterX - 35, screenCenterY + 20, 'soundOn').setScale(1.5).setInteractive({ useHandCursor: true }).setVisible(false).setDepth(1);
        this.soundOff = this.add.image(screenCenterX - 35, screenCenterY + 20, 'soundOff').setScale(1.5).setInteractive({ useHandCursor: true }).setVisible(false).setDepth(1);
        this.home = this.add.image(screenCenterX + 35, screenCenterY + 20, 'home').setScale(1.5).setInteractive({ useHandCursor: true }).setVisible(false).setDepth(1);
        this.restart = this.add.image(screenCenterX + 100, screenCenterY + 20, 'restart').setScale(1.5).setInteractive({ useHandCursor: true }).setVisible(false).setDepth(1);
        this.cancel = this.add.image(screenCenterX - 35, screenCenterY + 20, 'cancel').setScale(1.5).setInteractive({ useHandCursor: true }).setVisible(false).setDepth(1);
        this.confirm = this.add.image(screenCenterX + 35, screenCenterY + 20, 'confirm').setScale(1.5).setInteractive({ useHandCursor: true }).setVisible(false).setDepth(1);


        if(this.previousScene === 'Start') {
            this.play.x = screenCenterX - 35;
            this.play.visible = true;
            this.soundOn.x = screenCenterX + 35;
            this.soundOff.x = screenCenterX + 35;
            
        } else if(this.previousScene === 'Hallway'){
            this.play.x = screenCenterX - 65;
            this.play.visible = true;
            this.soundOn.x = screenCenterX ;
            this.soundOff.x = screenCenterX;
            this.restart.x = screenCenterX + 65;
            this.restart.visible = true;

        } else {
            this.restart.visible = true;
            this.home.visible = true;
        }

        this.settingsSound = localStorage.getItem('sound');

        if(this.settingsSound && this.settingsSound === '0') {
            this.soundOff.visible = true;
        } else {
            this.soundOn.visible = true;
        }

        this.play.on('pointerdown', () => {
            this.play.setAlpha(0.4)
        }).on('pointerup', () => {
            this.scene.resume(this.previousScene);
            this.scene.stop();
            this.play.setAlpha(1)

        });

        this.soundOn.on('pointerdown', () => {
            this.soundOn.setAlpha(0.4)
        }).on('pointerup', () => {
            localStorage.setItem('sound', 0);
            this.soundOn.visible = false;
            this.soundOff.visible = true;
            this.soundOn.setAlpha(1)

        });

        this.soundOff.on('pointerdown', () => {
            this.soundOff.setAlpha(0.4)
        }).on('pointerup', () => {
            localStorage.setItem('sound', 1);
            this.soundOn.visible = true;
            this.soundOff.visible = false;
            this.soundOff.setAlpha(1)

        });

        this.home.on('pointerdown', () => {
            this.home.setAlpha(0.4)
        }).on('pointerup', () => {
            this.textPausa.visible = false;
            this.play.visible = false;
            this.soundOn.visible = false;
            this.soundOff.visible = false;
            this.home.visible = false;
            this.restart.visible = false;
            this.textHome.visible = true;
            this.confirm.visible = true;
            this.cancel.setX(screenCenterX - 35);
            this.cancel.setY(screenCenterY + 20);
            this.cancel.visible = true;
            this.home.setAlpha(1)

        });

        this.restart.on('pointerdown', () => {
            this.restart.setAlpha(0.4)
        }).on('pointerup', () => {
            this.textPausa.visible = false;
            this.play.visible = false;
            this.soundOn.visible = false;
            this.soundOff.visible = false;
            this.home.visible = false;
            this.restart.visible = false;
            this.textRestart.visible = true;
            this.textRestartCharacter.visible = true;
            this.textRestartCharacter2.visible = true;
            // this.confirm.visible = true;
            this.cancel.setX(screenCenterX)
            this.cancel.setY(screenCenterY + 40)
            this.cancel.visible = true;
            this.restart.setAlpha(1)

        });

        this.confirm.on('pointerdown', () => {
            this.confirm.setAlpha(0.4)
        }).on('pointerup', () => {
            this.confirm.setAlpha(1)
            this.scene.stop();
            if(this.textHome.visible) {
                this.scene.resume(this.previousScene, {goHome: true});

            }

            if(this.textRestartAll.visible) {
                localStorage.removeItem('noL');
                localStorage.removeItem('ch');
                localStorage.removeItem('sI');
                localStorage.removeItem('td');
                this.scene.resume(this.previousScene, {goStart: true});


            }
            
            if(this.textCharacter.visible) {
                localStorage.removeItem('ch');
                this.scene.resume(this.previousScene, {goStart: true});
            }
        });

        this.textRestartCharacter.on('pointerdown', () => {
            this.textRestartCharacter.setAlpha(0.4)
        }).on('pointerup', () => {
            this.textPausa.visible = false;
            this.play.visible = false;
            this.soundOn.visible = false;
            this.soundOff.visible = false;
            this.home.visible = false;
            this.restart.visible = false;
            this.textCharacter.visible = true;
            this.textRestart.visible = false;
            this.textRestartCharacter.visible = false;
            this.textRestartCharacter2.visible = false;
            this.confirm.visible = true;
            this.cancel.setX(screenCenterX - 35);
            this.cancel.setY(screenCenterY + 20);
            this.cancel.visible = true;
            this.textRestartCharacter.setAlpha(1);
        });
        
        this.textRestartCharacter2.on('pointerdown', () => {
            this.textRestartCharacter2.setAlpha(0.4)
        }).on('pointerup', () => {
            this.textPausa.visible = false;
            this.play.visible = false;
            this.soundOn.visible = false;
            this.soundOff.visible = false;
            this.home.visible = false;
            this.restart.visible = false;
            this.textRestartAll.visible = true;
            this.textRestart.visible = false;
            this.textRestartCharacter.visible = false;
            this.textRestartCharacter2.visible = false;
            this.confirm.visible = true;
            this.cancel.setX(screenCenterX - 35);
            this.cancel.setY(screenCenterY + 20);
            this.cancel.visible = true;
            this.textRestartCharacter2.setAlpha(1);
        });

        this.cancel.on('pointerdown', () => {
            this.cancel.setAlpha(0.4)
        }).on('pointerup', () => {
            this.cancel.setAlpha(1)
            this.textPausa.visible = true;
            this.play.visible = true;
            if(this.previousScene !== 'Hallway') {
                this.home.visible = true;
            }
            this.restart.visible = true;
            this.textHome.visible = false;
            this.confirm.visible = false;
            this.cancel.visible = false;
            this.textRestart.visible = false;
            this.textRestartAll.visible = false;
            this.textRestart.visible = false;
            this.textCharacter.visible = false;
            this.textRestartCharacter.visible = false;
            this.textRestartCharacter2.visible = false;
            if(this.settingsSound && this.settingsSound === '0') {
                this.soundOff.visible = true;
            } else {
                this.soundOn.visible = true;
            }
        });

        
    }
    
    update() {


    }


}